import React from "react";
import { Button } from "@/components/ui/button";
import { Youtube, Sparkles } from "lucide-react";
import { useUI } from "@/context/UIContext";

export function EmptyState({
  title = "Start analyzing videos",
  description = "Paste a YouTube video or Short to discover what makes it perform.",
  showAction = true,
  icon: Icon = Youtube,
}) {
  const { openAnalyze } = useUI();
  return (
    <div
      className="relative flex flex-col items-center justify-center text-center py-20 px-6 rounded-2xl border border-dashed border-border overflow-hidden"
      data-testid="empty-state"
    >
      <div className="absolute inset-0 grid-bg-sm radial-fade opacity-40 pointer-events-none" />
      <span className="relative flex h-16 w-16 items-center justify-center rounded-2xl bg-primary/10 text-primary mb-5 neon-primary">
        <Icon className="h-7 w-7" />
      </span>
      <h3 className="relative font-display text-2xl font-bold tracking-tight">{title}</h3>
      <p className="relative text-sm text-muted-foreground mt-2 max-w-sm">{description}</p>
      {showAction && (
        <Button onClick={openAnalyze} className="relative mt-6 gap-2" data-testid="empty-analyze-btn">
          <Sparkles className="h-4 w-4" /> Analyze YouTube Video
        </Button>
      )}
    </div>
  );
}
